import User from '../models/User';

export const getStudentInitials = (
  user: Pick<User, 'firstName' | 'lastName' | 'name' | 'nickname'> | null | undefined,
): string => {
  if (!user) return '';

  const first = user.firstName?.trim();
  const last = user.lastName?.trim();
  if (first || last) {
    return `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase();
  }

  const source = (user.name || user.nickname || '').trim();
  if (!source) return '';

  const parts = source.split(/\s+/);
  const initials = parts.length === 1 ? parts[0].slice(0, 1) : `${parts[0][0]}${parts[parts.length - 1][0]}`;
  return initials.toUpperCase();
};
